(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMuteToggles() {
      document.querySelectorAll('[data-mute-toggle]').forEach(function (btn) {
        // Avoid double-initialising
        if (btn.dataset.muteInit) return;
        btn.dataset.muteInit = 'true';

        btn.addEventListener('click', function () {
          var container = btn.closest('deferred-media');
          var video = container && container.querySelector('video');
          if (!video) return;

          video.muted = !video.muted;

          var mutedIcon = btn.querySelector('.video-mute-toggle__icon--muted');
          var unmutedIcon = btn.querySelector('.video-mute-toggle__icon--unmuted');

          if (video.muted) {
            mutedIcon.style.display = '';
            unmutedIcon.style.display = 'none';
            btn.setAttribute('aria-label', 'Unmute video');
          } else {
            mutedIcon.style.display = 'none';
            unmutedIcon.style.display = '';
            btn.setAttribute('aria-label', 'Mute video');
          }
        });
      });
    }

    // Run on DOMContentLoaded and also after Shopify section re-renders
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMuteToggles);
    } else {
      initMuteToggles();
    }

    document.addEventListener('shopify:section:load', initMuteToggles);
  })();
  } catch(e) { console.error(e); }
})();

})();
